export function setupMathJax(classToAttachTo) {
  window
  && window.MathJax
  && window.MathJax.Hub.Queue(['Typeset', window.MathJax.Hub, classToAttachTo]);
}
